export default "__VITE_ASSET__BnpZATwJ__"